<template>
  <div v-if="hasBio" class="author-info">
    <div class="author-info__inner">
      <AuthorAvatar v-if="hasPoster" :src="posterUrl" :size="48" />
      <div class="author-info__content">
        <div
          class="author-info__text-wrap"
          :class="{ 'author-info__text-wrap--collapsible': !expanded && isTruncatable }"
          @click="expand"
        >
          <div
            ref="textEl"
            class="author-info__text"
            :class="{ 'author-info__text--collapsed': !expanded && isTruncatable }"
          >
            {{ bio }}
          </div>
          <span
            v-if="!expanded && isTruncatable"
            class="author-info__dots"
            aria-hidden="true"
          >
            <span class="author-info__dot"></span>
            <span class="author-info__dot"></span>
            <span class="author-info__dot"></span>
          </span>
        </div>
        <div
          v-if="expanded && isTruncatable"
          class="author-info__toggle"
          @click="collapse"
        >
          Свернуть
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthorAvatar from '@/components/blocks/author/AuthorAvatar.vue';

const COLLAPSED_LINES = 3;

export default {
  name: 'AuthorInfoBlock',
  components: {
    AuthorAvatar,
  },
  props: {
    bio: {
      type: String,
      default: '',
    },
    posterUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      expanded: false,
      isTruncatable: false,
    };
  },
  computed: {
    hasBio() {
      return this.bio.trim().length > 0;
    },
    hasPoster() {
      return this.posterUrl.trim().length > 0;
    },
  },
  watch: {
    bio() {
      this.expanded = false;
      this.isTruncatable = false;
      this.checkTruncation();
    },
  },
  mounted() {
    this.checkTruncation();
  },
  updated() {
    this.checkTruncation();
  },
  methods: {
    checkTruncation() {
      this.$nextTick(() => {
        const el = this.$refs.textEl;
        if (!el || this.expanded || !this.hasBio) {
          return;
        }
        const lineHeight = parseFloat(getComputedStyle(el).lineHeight) || 21;
        const maxCollapsedHeight = lineHeight * COLLAPSED_LINES;
        this.isTruncatable = el.scrollHeight > maxCollapsedHeight + 1;
      });
    },
    expand() {
      if (!this.expanded && this.isTruncatable) {
        this.expanded = true;
      }
    },
    collapse() {
      this.expanded = false;
      this.checkTruncation();
    },
  },
};
</script>

<style lang="scss" scoped>
.author-info {
  margin-top: 12px;

  &__inner {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px;
    background-color: var(--color-gray-light);
    border-radius: 8px;
  }

  &__content {
    flex: 1;
    min-width: 0;
  }

  &__text-wrap {
    position: relative;

    &--collapsible {
      cursor: pointer;
    }
  }

  &__text {
    color: var(--color-black);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;

    &--collapsed {
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }

  &__dots {
    position: absolute;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    gap: 3px;
    height: 21px;
    padding-left: 50px;
    padding-right: 10px;
    background: linear-gradient(
      to right,
      rgba(245, 245, 245, 0),
      var(--color-gray-light) 45%
    );
  }

  &__dot {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: var(--color-blue);
    flex-shrink: 0;
  }

  &__toggle {
    margin-top: 8px;
    color: var(--color-blue);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%;
    cursor: pointer;
  }
}
</style>
